module.exports = __webpack_public_path__ + "img/search.99b5f804.png";